import React from 'react';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import logo from '../asset/logo512.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          
          {/* Left - Logo + Company Name */}
          <div className="flex items-center space-x-2">
            <img
              src={logo}
              alt="NIRA IT Solutions Logo"
              className="h-6 w-6 rounded-full object-cover"
            />
            <div className="text-sm text-gray-700 dark:text-gray-300">
              <span className="font-medium">NIRA IT Solutions</span>
              <span className="text-gray-500 dark:text-gray-400 ml-2">© {currentYear}</span>
            </div>
          </div>

          {/* Center - Contact Information */}
          <div className="flex flex-wrap justify-center items-center gap-4 text-sm">
            <div className="flex items-center space-x-1.5 text-gray-600 dark:text-gray-400">
              <FaEnvelope className="text-blue-500 text-xs" />
              <a 
                href="mailto:support@niraitsolutions.com"
                className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                support@niraitsolutions.com
              </a>
            </div>
            <div className="flex items-center space-x-1.5 text-gray-600 dark:text-gray-400">
              <FaPhoneAlt className="text-green-500 text-xs" />
              <a 
                href="tel:+918072862584"
                className="hover:text-green-600 dark:hover:text-green-400 transition-colors"
              >
                +91 80728 62584
              </a>
            </div>
          </div>

          {/* Right - Simple tagline */}
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Innovative IT Solutions
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;